import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { clearCredentials } from "./auth.slice";
import type { RootState } from "./index";

export interface PermissionRole {
    roleId: string;
    roleName: string;
}

export interface PermissionsState {
    allowedActions: string[];
    roles: PermissionRole[];
}

const initialState: PermissionsState = {
    allowedActions: [],
    roles: [],
};

function clearPermissionsReducer(state: PermissionsState): void {
    state.allowedActions = [];
    state.roles = [];
}

export const permissionsSlice = createSlice({
    name: "permissions",
    initialState,
    reducers: {
        setPermissions(state, action: PayloadAction<PermissionsState>) {
            state.allowedActions = action.payload.allowedActions;
            state.roles = action.payload.roles;
        },
        clearPermissions: clearPermissionsReducer,
    },
    extraReducers(builder) {
        // Mirror logout so permissions are cleared whenever auth is cleared.
        builder.addCase(clearCredentials, clearPermissionsReducer);
    },
});

export const { setPermissions, clearPermissions } = permissionsSlice.actions;

export const selectPermissions = (state: RootState) => state.permissions;
export const selectAllowedActions = (state: RootState) => state.permissions.allowedActions;
